// extracted by mini-css-extract-plugin
export default {"vendorCardItem":"vendorCard_vendorCardItem__X3gvg","vendorCardInfoType":"vendorCard_vendorCardInfoType__CJz02","textOverflow":"vendorCard_textOverflow__y9Kms"};